import React from 'react';
import { ContainerGrid, Container, LeftGrid } from '@components/LayoutGrid';
import Heading from '@components/Heading';
import Text from '@components/Text';

export interface NotFoundProps {}

function NotFound() {
  return (
    <Container>
      <ContainerGrid>
        <LeftGrid>
          <br /><br /><br /><br /><br /><br /><br /><br />
          <Heading variant="default" fontWeight="normal">Page not found</Heading>
          <Text> We can&apos;t seem to find the page you&apos;re looking for. </Text>
          <br /><br /><br /><br /><br /><br /><br /><br />
          <br /><br /><br /><br /><br /><br /><br /><br />
        </LeftGrid>
      </ContainerGrid>
    </Container>
  )
};

export default NotFound;
